import React from 'react';

export default function HomePlatform() {
  return (
    <>
      <section className="platform-section">
        <div className="container">
          {/* Heading */}
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="heading-text">
                <h4 className="heading center-heading">
                  Scalable enterprise platform
                </h4>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="row">
            {/* Shipments */}
            <div className="col-6 col-md-6 col-lg-3">
              <div className="platform-text">
                <div className="heading">

                  <span className="stat-number">
                    25
                  </span> Mn
                </div>
                <p>
                  Shipments per <br /> day
                </p>
              </div>
            </div>

            {/* Modes */}
            <div className="col-6 col-md-6 col-lg-3">
              <div className="platform-text">
                <div className="heading">
                  <span className="stat-number">
                    7
                    </span> Modes
                </div>
                <p>
                  Air, LTL/FTL, LCL/FCL, <br />
                  parcel, charter, owned fleet
                </p>
              </div>
            </div>

            {/* Carrier network */}
            <div className="col-6 col-md-6 col-lg-3">
              <div className="platform-text">
                <div className="heading">
                  <span className="stat-number">
                    40000
                  </span>+
                </div>
                <p>
                  Global carrier <br /> network
                </p>
              </div>
            </div>

            {/* Freight spend */}
            <div className="col-6 col-md-6 col-lg-3">
              <div className="platform-text last-playform">
                <div className="heading">
                  $<span className="stat-number">
                    25
                  </span> Bn
                </div>
                <p>
                  Freight spend under <br /> management
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}




